import { Tag } from 'antd'
import styled from 'styled-components'

const StyledMenuAvailabiltyLabel = styled(Tag)`
  margin-top: 0.5rem;
`

export default StyledMenuAvailabiltyLabel
